import { formatNumberOnUnitMeasure } from '../../utils/helper'
import { COLOR_MAP } from '../../utils/theme'
import './standardDeviationLegend.css'

const StandardDeviationLegend = ({
  legendRange,
  colors,
  scaleType,
  isTheme = false,
  divBinnedMidValue = null,
  unitMeasure,
  decimals,
  legendValuesForStd,
  noDataColor,
}) => {
  let legendRangeDivs =
    legendValuesForStd &&
    legendValuesForStd.length > 0 &&
    legendValuesForStd.map((item, index) => {
      if (
        divBinnedMidValue !== null &&
        legendRange.length % 2 === 0 &&
        index === legendRange.length / 2 - 1
      ) {
        return (
          <>
            <div className="map-legand-label" key={item}>
              {/* format number to K,M,B etc and round off decimals */}
              {item !== '' && item !== undefined && item !== null
                ? unitMeasure
                  ? formatNumberOnUnitMeasure({
                      value: item,
                      unitMeasure,
                      decimals,
                    })
                  : Intl.NumberFormat('en', { notation: 'compact' }).format(
                      item
                    )
                : ''}
              {/* {legendValuesForStd[index] && (
                  <>
                    <br />({legendValuesForStd[index]})
                  </>
                )} */}
            </div>
            <div className="map-legand-label mid-value" key={divBinnedMidValue}>
              {/* format number to K,M,B etc and round off decimals */}
              {divBinnedMidValue !== '' &&
              divBinnedMidValue !== undefined &&
              divBinnedMidValue !== null
                ? unitMeasure
                  ? formatNumberOnUnitMeasure({
                      value: divBinnedMidValue,
                      unitMeasure,
                      decimals,
                    })
                  : Intl.NumberFormat('en', { notation: 'compact' }).format(
                      divBinnedMidValue
                    )
                : ''}
            </div>
          </>
        )
      } else {
        return (
          <div
            className="map-legand-label"
            style={{ flex: '0 0 12%', maxWidth: '12%' }}
            key={item}
          >
            {/* format number to K,M,B etc and round off decimals */}
            {item !== '' && item !== undefined && item !== null
              ? unitMeasure
                ? formatNumberOnUnitMeasure({
                    value: item,
                    unitMeasure,
                    decimals,
                  })
                : Intl.NumberFormat('en', { notation: 'compact' }).format(item)
              : ''}
            {/* {legendValuesForStd[index] && (
                <>
                  <br />({legendValuesForStd[index]})
                </>
              )} */}
          </div>
        )
      }
    })

  let colorsDiv =
    colors &&
    colors.length > 0 &&
    colors.map((item, index) => (
      <div className="legend-item std-legend-item">
        {/* <div
          style={{
            backgroundColor: item,
            width: '20px',
            height: '20px',
            display: 'inline-block',
            marginRight: '10px',
          }}
        ></div> */}
        <span className="color-box" style={{ backgroundColor: item }}></span>
        <span style={{ fontSize: '12px' }}>{legendValuesForStd[index]}</span>
      </div>
    ))

  // temp fix for colors order
  let updatedColorsDiv = []
  updatedColorsDiv[0] = colorsDiv[3]
  updatedColorsDiv[1] = colorsDiv[0]
  updatedColorsDiv[2] = colorsDiv[4]
  updatedColorsDiv[3] = colorsDiv[1]
  updatedColorsDiv[4] = colorsDiv[5]
  updatedColorsDiv[5] = colorsDiv[2]

  return (
    <div className="std-legend-container">
      <div className="legend-item std-legend-item">
        {/* <div
          style={{
            backgroundColor: COLOR_MAP.not_available,
            width: '20px',
            height: '20px',
            display: 'inline-block',
            marginRight: '10px',
          }}
        ></div> */}
        <span
          className="color-box"
          style={{ backgroundColor: noDataColor }}
        ></span>
        <span style={{ fontSize: '12px', alignContent: 'center' }}>
          No data
        </span>
      </div>
      {updatedColorsDiv}
      <div className="std-legend-item"></div>
    </div>
  )
}
export default StandardDeviationLegend
